import type { Budget } from "./presents";

export interface GiftPreset {
  slug: string;
  title: string;
  heading: string;
  blurb: string;
  recipient: string;
  budget: Budget;
  vibe: string;
  occasion?: boolean;
}

const p = (slug: string, heading: string, blurb: string, recipient: string, budget: Budget, vibe: string, occasion = false): GiftPreset =>
  ({ slug, heading, blurb, recipient, budget, vibe, occasion, title: `${heading} – Gift Ideas | DITHER Present Finder` });

export const GIFT_PRESETS: GiftPreset[] = [
  p("gifts-for-dad-under-50", "Gifts for Dad under £50", "Thoughtful, funny and useful presents for Dad that won't break the bank.", "parent", "20-50", "funny"),
  p("gifts-for-mum-under-50", "Cosy gifts for Mum under £50", "Comforting, pampering presents to make Mum feel spoilt.", "parent", "20-50", "cosy"),
  p("funny-gifts-for-coworkers", "Funny gifts for coworkers under £20", "Secret Santa and leaving-do gifts guaranteed to get a laugh.", "coworker", "under-20", "funny"),
  p("gifts-for-friends-under-20", "Gifts for friends under £20", "Small, fun presents your friends will actually use.", "friend", "under-20", "funny"),
  p("foodie-gifts-for-friends", "Foodie gifts for friends", "Tasty treats and kitchen upgrades for the friend who loves to eat.", "friend", "20-50", "foodie"),
  p("romantic-gifts-for-partner", "Fancy gifts for your partner", "Big-gesture, special-occasion presents for your other half.", "partner", "splurge", "fancy"),
  p("adventurous-gifts-for-partner", "Adventure gifts for couples", "Experiences and days out to share with your partner.", "partner", "50-100", "adventurous"),
  p("tech-gifts-for-siblings", "Tech gifts for brothers & sisters", "Gadgets and clever kit for the techy sibling.", "sibling", "50-100", "techy"),
  p("creative-gifts-for-kids", "Creative gifts for kids", "Make-it, build-it and paint-it presents that beat screen time.", "kid", "20-50", "creative"),
  p("practical-gifts-for-parents", "Practical gifts for parents", "Genuinely useful presents for parents who 'don't need anything'.", "parent", "50-100", "practical"),
  p("birthday-gift-ideas", "Birthday gift ideas for friends", "Treat-yourself birthday presents that feel special without the stress.", "friend", "20-50", "fancy", true),
  p("christmas-gift-ideas", "Christmas gift ideas for your partner", "Cosy, thoughtful Christmas presents for your other half.", "partner", "50-100", "cosy", true),
  p("secret-santa-gift-ideas", "Secret Santa gifts under £20", "Tasty, crowd-pleasing Secret Santa presents for the office.", "coworker", "under-20", "foodie", true),
  p("funny-gift-ideas", "Funny gift ideas for siblings", "Gag gifts and daft presents for the sibling who needs a laugh.", "sibling", "20-50", "funny", true),
];

export const giftPresetBySlug = (slug?: string) => GIFT_PRESETS.find((g) => g.slug === slug);
